module.exports = __webpack_public_path__ + "img/header_closeP.add42c59.png";